import { LogoMark } from './LogoMark';
import { useTenant } from '../tenant/TenantProvider';
import { useTheme } from '../theme/ThemeProvider';
import defaultStrings from '../tenant/defaultStrings';

export function BrandMark({ className }) {
  const { brand } = useTenant();
  if (brand.faviconUrl) {
    return <img className={`brand__mark brand__mark--image ${className ?? ''}`} src={brand.faviconUrl} alt="" />;
  }
  return (
    <span className={`brand__mark ${className ?? ''}`} aria-hidden="true">
      {brand.name === defaultStrings.brand.name ? <LogoMark /> : brand.name.trim().charAt(0)}
    </span>
  );
}

export function Brand({ showName = true }) {
  const { brand } = useTenant();
  const { theme } = useTheme();
  const logo = theme === 'dark' && brand.logoDarkUrl ? brand.logoDarkUrl : brand.logoUrl;
  const isDefaultBrand = brand.name === defaultStrings.brand.name;

  if (logo) {
    return <img className="brand__logo" src={logo} alt={brand.name} />;
  }
  return (
    <>
      <span className="brand__mark" aria-hidden="true">
        {isDefaultBrand ? <LogoMark /> : brand.name.trim().charAt(0)}
      </span>
      {showName ? <span className="brand__name">{brand.name}</span> : <span className="visually-hidden">{brand.name}</span>}
    </>
  );
}
